'use client'
import { useState } from 'react'

interface IProps {
  ifFlex?: boolean
  arrayOfData: { label: string | null; value: string | null }[]
  showMore?: boolean
}

export const LegacyProfileDetails = ({ ifFlex, arrayOfData, showMore = false }: IProps) => {
  const [showFullText, setShowFullText] = useState<boolean[]>(arrayOfData.map(() => false))

  const handleToggleFullText = (index: number) => {
    setShowFullText((prevState) => {
      const newState = [...prevState]
      newState[index] = !newState[index]
      return newState
    })
  }
  return (
    <div
      className={` text-sm font-medium mb-4 ${
        ifFlex ? 'md:grid grid-cols-2 md:max-h-[48px] md:mb-1' : ''
      }`}
    >
      {arrayOfData.map((item, index) => {
        return (
          item.label &&
          item.value && (
            <div
              className={`${showFullText[index] ? 'line-clamp-none' : 'line-clamp-1'}`}
              key={index}
            >
              <label className={'text-gray-600'}>{item.label}:</label>
              <span
                className='cursor-default'
                onClick={() => showMore && handleToggleFullText(index)}
              >
                {' '}
                {item.value}{' '}
              </span>
            </div>
          )
        )
      })}
    </div>
  )
}

export default LegacyProfileDetails
